
import { Vue, Component } from "vue-property-decorator";
import TopBarSection from "@/components/Reusable/AppLayout/TopBar/TopBarSection.vue";
import { configStore, uiStore } from "@/store/store";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: { Icon, TopBarSection }
})
export default class InlineEditorTopbarIndicator extends Vue {
  get block() {
    return configStore.globalBlocks.find(
      b => uiStore.inlineEditingContext?.blockId === b.id
    );
  }

  closeEditor() {
    uiStore.resetInlineEditingContext();
  }
}
